<template>
  <Slider>
    <MDCSlot />
  </Slider>
</template>

<script lang="ts" setup>
import { Slider } from '@crearis/ui'
</script>
